import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const EditProblem = () => {
  const [problems, setProblems] = useState([]);
  const [editedProblem, setEditedProblem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchProblems = async () => {
      try {
        const response = await axios.get(
          "https://cp-tracker-backend.onrender.com/problem/getAllProblems"
        );
        setProblems(response.data);
      } catch (error) {
        console.error("Error fetching problems:", error);
      }
    };

    fetchProblems();
  }, []);

  const handleDelete = async (id) => {
    try {
      const confirmDelete = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (confirmDelete.isConfirmed) {
        await axios.delete(
          `https://cp-tracker-backend.onrender.com/problem/deleteProblem`,
          {
            data: { problemId: id },
          }
        );
        setProblems(problems.filter((problem) => problem._id !== id));
        Swal.fire("Deleted!", "Your problem has been deleted.", "success");
      }
    } catch (error) {
      console.error("Error deleting problem:", error);
      Swal.fire(
        "Error",
        "An error occurred while deleting the problem.",
        "error"
      );
    }
  };

  const handleEdit = (problem) => {
    setEditedProblem(problem);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSaveChanges = async () => {
    try {
      await axios.put(
        `https://cp-tracker-backend.onrender.com/problem/updateProblem`,
        editedProblem
      );
      setShowModal(false);
      // You might want to refresh the problem list after editing
    } catch (error) {
      console.error("Error updating problem:", error);
    }
  };

  return (
    <div>
      <h2>Edit Problems</h2>
      <table>
        <thead>
          <tr>
            <th>Rating</th>
            <th>Link</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {problems.map((problem) => (
            <tr key={problem._id}>
              <td>{problem.problemRating}</td>
              <td>
                <a href={problem.problemLink} target="_blank" rel="noreferrer">
                  {problem.problemName}
                </a>
              </td>
              <td>{problem.problemStatus}</td>
              <td>
                <button style={{marginRight: "5px"}} onClick={() => handleDelete(problem._id)}>
                  Delete
                </button>
                <button onClick={() => handleEdit(problem)}>Edit</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={handleCloseModal}>
              &times;
            </span>
            <h2>Edit Problem</h2>
            <form>
              <div className="form-group">
                <label htmlFor="problemRating">Rating:</label>
                <input
                  type="text"
                  id="problemRating"
                  value={editedProblem.problemRating}
                  onChange={(e) =>
                    setEditedProblem({
                      ...editedProblem,
                      problemRating: e.target.value,
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label htmlFor="problemName">Name:</label>
                <input
                  type="text"
                  id="problemName"
                  value={editedProblem.problemName}
                  onChange={(e) =>
                    setEditedProblem({
                      ...editedProblem,
                      problemName: e.target.value,
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label htmlFor="problemLink">Link:</label>
                <input
                  type="text"
                  id="problemLink"
                  value={editedProblem.problemLink}
                  onChange={(e) =>
                    setEditedProblem({
                      ...editedProblem,
                      problemLink: e.target.value,
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label htmlFor="problemStatus">Status:</label>
                <input
                  type="text"
                  id="problemStatus"
                  value={editedProblem.problemStatus}
                  onChange={(e) =>
                    setEditedProblem({
                      ...editedProblem,
                      problemStatus: e.target.value,
                    })
                  }
                />
              </div>
              <button type="button" onClick={handleSaveChanges}>
                Save Changes
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditProblem;
